export default theme => {
  return {
    container: {
      height: 500
    }
  }
}
